import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { App } from './Components/App/App';
import { Routes, Route, HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './Services/Store';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from './AppSettings';
import { WikiPage } from './Pages/WikiPage';

const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={ store }>
      <HashRouter>
        <MsalProvider instance={ msalInstance }>
          <Routes>
            <Route path='*' element={ <App /> }>
              <Route path='*' element={ <WikiPage /> } />
            </Route>
          </Routes>
        </MsalProvider>
      </HashRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();